import APP_CONST from '../../constants';
import ActiveSessions from './';
import { ROUTER_CONST, $state } from '../../router';
import { ClientManager } from '../../services';

export default {
    name: 'activeSessions',
    url: '/account/active-sessions',
    component: ActiveSessions,
    layout: APP_CONST.LAYOUT_FULL,
    visibility: ROUTER_CONST.STATE_VISIBILITY_PRIVATE,
    resolve: [{   
        token: 'reject_clients',
        deps: ['$transition$'],
        resolveFn: () => {
            // mobile/desktop app users should never get access to the account 
            // pages so lets just force log them out in the event they end up on
            // this page.
            if ((ClientManager.hasClient() || ClientManager.hasApp()) && ClientManager.client() !== 'web') {
                $state.go('logout', {
                    client: ClientManager.client(),
                    app: ClientManager.app(),
                });
            }

            return true;
        }
    }]
};